export interface IMedicalRecordLogin {
    id: number,
    medicalRecordId: number,
    isEmailVerified: boolean,
    emailVerificationSentDateTime: string,
    isMobileVerified: boolean,
    mobileVerificationSentDateTime: string,
    registrationDateTime: string
}